var map = {
	"./bg.jpg": 1225,
	"./bg3.jpg": 1226,
	"./icon-calendar-payment.svg": 481,
	"./icon-impact-report.svg": 482,
	"./icon-maintenance.svg": 230,
	"./icon-prospectus.png": 1227,
	"./icon-quarterly-report.svg": 483,
	"./icon-tax-document.svg": 484,
	"./tutorial_1.png": 485,
	"./tutorial_2.png": 486,
	"./user/img-profile-UGMA.svg": 487,
	"./user/img-profile-advisor.svg": 161,
	"./user/img-profile-default-admin.svg": 231,
	"./user/img-profile-default.svg": 123,
	"./user/img-profile-institution.svg": 488,
	"./user/img-profile-joint.svg": 489,
	"./user/img-profile-trust.svg": 490
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2217;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*$
// module id = 2217
// module chunks = 1